import { Group, Stack, UnstyledButton } from '@mantine/core';
import MarkdownRenderer from '@repo/common/components/MarkdownRenderer';
import { useNavigate } from '@repo/common/hooks/useNavigate';
import { Banner, Text } from '@repo/foundations';
import dayjs from 'dayjs';
import type { IResourceContentProps } from '../../types';

export function ResourceIntegrationContent({
	selected,
}: IResourceContentProps) {
	const navigate = useNavigate();
	const timeLabel = selected.event.startsWith('extraction')
		? 'Extraction time'
		: 'Push time';
	const isSuccess = selected.event.includes('completed');
	const isFailed = selected.event.includes('failed');
	const isGithubChangeRequest = selected.event.includes(
		'github_change_request'
	);

	return (
		<Stack spacing="2xl">
			<UnstyledButton
				onClick={() => {
					if (selected.computedMetadata.integration) {
						navigate(
							`/integrations/${selected.computedMetadata.integration.id}`
						);
					}
				}}
			>
				<Text fw={600} size="xl">
					{selected.subject}
				</Text>
			</UnstyledButton>
			<Group>
				<Text color="text/secondary/default" size="sm">
					{timeLabel}
				</Text>
				<Text size="sm">
					{dayjs(selected.created_at).format('MMMM D, YYYY h:mm A')}
				</Text>
			</Group>
			{isSuccess && (
				<Banner
					message={
						<MarkdownRenderer inline>
							{selected.short_summary_markdown}
						</MarkdownRenderer>
					}
					tone="success"
					inCard
				/>
			)}
			{isFailed && (
				<Banner
					message={
						<MarkdownRenderer inline>
							{selected.short_summary_markdown}
						</MarkdownRenderer>
					}
					tone="critical"
					inCard
				/>
			)}
			{isGithubChangeRequest && Array.isArray(selected.metadata?.resources) && (
				<Banner
					title="Resources"
					message={selected.metadata?.resources?.join(', ')}
					tone="info"
					inCard
				/>
			)}
		</Stack>
	);
}
